<template>
  <div class="sidebar" :class="{ sidebar_dark: dark }">
    <div class="sidebar__content">
      <slot></slot>
    </div>
    <slot name="after" />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    dark?: boolean;
  }>(),
  {
    dark: false
  }
);
</script>

<style lang="scss">
.sidebar {
  background-color: var(--color-background-deep);
  height: 100%;
  max-height: 100%;
  width: var(--sidebar-width, 22rem);
  flex-shrink: 0;
  box-sizing: border-box;
  box-shadow: 0 0 1rem var(--color-shadow-2);
  z-index: 1;
  display: flex;
  flex-direction: column;
  contain: layout size;

  @supports (-moz-appearance: none) {
    // only firefox supports this fully
    // and it interferes with colors in chrome
    scrollbar-width: thin;
  }

  &__image {
    max-width: 100%;
    display: block;
  }

  &__content {
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    @supports (-moz-appearance: none) {
      // only firefox supports this fully
      // and it interferes with colors in chrome
      scrollbar-width: thin;
    }
  }

  &__close {
    position: absolute;
    top: 1rem;
    left: 100%;
    z-index: 5;
    display: flex;
    align-items: center;
    border-top-right-radius: 40rem;
    border-bottom-right-radius: 40rem;
    background-color: var(--color-text-light);
    padding: 0.5em;
    padding-left: 0.25em;
    padding-right: 0.75em;
    color: var(--color-action-contrast);
    transition: background-color 125ms;
    &__text {
      padding: 0 0.5em;
      white-space: nowrap;
    }
    &:hover {
      background-color: var(--color-dark);
    }
  }

  &_dark {
    background-color: var(--color-background-medium);
  }

  &_first {
    z-index: 10;
    transform: translate3d(0, 0, 0);
    position: relative;
  }
  &_second,
  &_third,
  &_fourth {
    position: absolute !important;
    top: 0;
    transition: transform 200ms;
    transform: translate3d(0, 0, 0);
  }
  &_second {
    left: var(--sidebar-width, 22rem);
    z-index: 9;

    &.is-hidden {
      transform: translate3d(-90%, 0, 0);
      transition: transform 400ms ease-in-out;
    }
  }
  &_third {
    left: calc(var(--sidebar-width, 22rem) * 2);
    z-index: 8;

    &.is-hidden {
      transform: translate3d(-180%, 0, 0);
      transition: transform 400ms ease-in-out;
    }
  }
  &_fourth {
    left: calc(var(--sidebar-width, 22rem) * 3);
    z-index: 7;

    &.is-hidden {
      transform: translate3d(-270%, 0, 0);
      transition: transform 400ms ease-in-out;
    }
  }
}
</style>
